__turbopack_context__.v({
  "button": "CtaStack-module-scss-module__P_pjWq__button",
  "container": "CtaStack-module-scss-module__P_pjWq__container",
  "heading": "CtaStack-module-scss-module__P_pjWq__heading",
});
